import { BackendTypeServer } from "../../domain/people";

export enum AccountType {
  public = "public",
  member = "member",
  admin = "admin",
}

export enum ProviderTypeServer {
  AWS = "aws_cloudbridge_backend_options",
  GCP = "gcp_cloudbridge_backend_options",
}

export interface BaseAccount {
  type: AccountType;
  id: number;
  slug: string;
  name: string;
  avatarUrl: string;
}

export interface AccountPublic extends BaseAccount {
  type: AccountType.public;
}

export interface Organization {
  name: string;
}

export interface AccountMember extends BaseAccount {
  type: AccountType.member;
  coreLimit: number;
  creditLimit: number;
  earlyAdopter: boolean;
  activeBackend: BackendTypeServer | null;
  active: boolean;
  membersLimit: number;
  configuredCustomerHosted: boolean;
  canUseCoiledHosted: boolean;
  setupComplete: boolean;
  organization: Organization | null;
}

export type UserListSchema = {
  id: number;
  email: string;
  username: string;
  firstName?: string;
  lastName?: string;
  avatarUrl?: string;
  title?: string;
};

export type WorkspaceMemberBaseSchema = {
  isAdmin: boolean;
  coreLimit: number;
  creditLimit: number;
};
export type WorkspaceMemberSchema = WorkspaceMemberBaseSchema & {
  id: number;
  user: UserListSchema;
};

export type LimitOffsetPaginationResponse<T> = {
  items: T[];
  count: number;
};

export type WorkspaceInvitationSchema = WorkspaceMemberBaseSchema & {
  user: undefined;
  email: string;
  inviter: {
    id: number;
    username: string;
    firstName: string;
    lastName: string;
    avatarUrl: string;
    isStaff: boolean;
  };
  key: string;
  id: string;
};

export type LegacyPaginationResponse<T> = {
  count: number;
  next?: string;
  previous?: string;
  results: T[];
};
